<template>
    <div class="sales-signup-page">
        <!--Sales header-->
        <sales-header></sales-header>
        <!--Account sign up-->
        <sales-account-signup></sales-account-signup>
        <!--Sales footer-->
        <sales-footer></sales-footer>
    </div>
</template>
<script>
import SalesHeader from "./sales/SalesHeader.vue";
import SalesAccountSignup from "./sales/SalesAccountSignup.vue";

import SalesFooter from "./sales/SalesFooter.vue";

export default {
    name: "SalesSignup",

    data: function () {
        return {};
    },
    mounted: function () {},
    computed: {},
    methods: {},
    components: {
        SalesHeader,
        SalesAccountSignup,
        SalesFooter,
    },
};
</script>
